module.exports = "/_next/static/images/TeamPlan-xs-6b66033ade1a271b646f25e993e3613c.png";